/* A recessed strip between the table header and the rows. It reads as an annotation on the list
   rather than another control, which is why it takes the sunken surface the rail takes and not a
   raised one. */
:host {
  display: block;
  border-bottom: 1px solid var(--agwa-border);
  background: var(--agwa-surface-sunken);
}

/* One line's height is held whether or not anything is filtered. A summary that appeared only
   once a filter was applied would push every row down at the moment of filtering, which is the
   defect the rail exists to remove. */
/* Normal text flow rather than a flex row. As a flex container every text node became an item with
   a gap around it, which detached the commas and the closing full stop from the words they belong
   to - punctuation floating in the middle of a sentence. Chips are inline-flex so they sit in the
   line like a word. */
.summary {
  min-height: 1.75rem;
  margin: 0;
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: var(--agwa-text-muted);
}

.summary b {
  font-weight: 600;
  color: var(--agwa-text);
}

/* The connective is deliberately quieter than the values it joins: the eye should land on what is
   being filtered for, and pick up the OR only if it is checking why a row survived. */
.or {
  color: var(--agwa-text-subtle);
}

.clause {
  display: inline-flex;
  align-items: baseline;
  vertical-align: baseline;
  gap: 0.25rem;
  padding: 0 0.1rem 0 0.35rem;
  border: 1px solid var(--agwa-border);
  border-radius: 3px;
  background: var(--agwa-surface);
}

.clause sl-icon-button {
  font-size: 0.6875rem;
  align-self: center;
}

.clause sl-icon-button::part(base) {
  padding: 0 0.1rem;
  color: var(--agwa-text-subtle);
}

.clause sl-icon-button::part(base):hover {
  color: var(--agwa-danger-text);
}

.clause sl-icon-button::part(base):focus-visible {
  outline: 2px solid var(--agwa-accent);
  outline-offset: 1px;
  border-radius: 2px;
}
